import { NavLink } from 'react-router-dom';

type IconProps = { className?: string };

function PotIcon({ className }: IconProps) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
      <path d="M4 9h16v6a4 4 0 0 1-4 4H8a4 4 0 0 1-4-4V9z" />
      <path d="M2 9h20M8 9V6m8 3V6" strokeLinecap="round" />
    </svg>
  );
}
function FridgeIcon({ className }: IconProps) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
      <rect x="6" y="2" width="12" height="20" rx="2" />
      <path d="M6 10h12M10 5v2M10 13v3" strokeLinecap="round" />
    </svg>
  );
}
function CalendarIcon({ className }: IconProps) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
      <rect x="3" y="4" width="18" height="17" rx="2" />
      <path d="M3 9h18M8 2v4M16 2v4" strokeLinecap="round" />
    </svg>
  );
}
function FamilyIcon({ className }: IconProps) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
      <circle cx="8" cy="8" r="3" />
      <circle cx="17" cy="9" r="2.5" />
      <path d="M2 20c0-3.3 2.7-6 6-6s6 2.7 6 6M14.5 20c0-2.5 1.6-4.5 4-4.5" strokeLinecap="round" />
    </svg>
  );
}
function BookIcon({ className }: IconProps) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
      <path d="M5 4a2 2 0 0 1 2-2h12v18H7a2 2 0 0 0-2 2V4z" />
      <path d="M9 7h7M9 11h7" strokeLinecap="round" />
    </svg>
  );
}

const TABS = [
  { to: '/', label: 'Готовить', Icon: PotIcon, end: true },
  { to: '/pantry', label: 'Холодильник', Icon: FridgeIcon, end: false },
  { to: '/plan', label: 'Меню', Icon: CalendarIcon, end: false },
  { to: '/family', label: 'Семья', Icon: FamilyIcon, end: false },
  { to: '/my', label: 'Рецепты', Icon: BookIcon, end: false },
];

export function BottomNav() {
  return (
    <nav className="safe-bottom fixed inset-x-0 bottom-0 z-10 border-t border-black/5 bg-white/90 shadow-nav backdrop-blur-lg">
      <ul className="mx-auto flex max-w-md">
        {TABS.map(({ to, label, Icon, end }) => (
          <li key={to} className="flex-1">
            <NavLink
              to={to}
              end={end}
              className={({ isActive }) =>
                `flex flex-col items-center gap-1 pb-2 pt-2.5 text-[11px] font-medium transition-colors ${
                  isActive ? 'text-primary-600' : 'text-ink/55'
                }`
              }
            >
              {({ isActive }) => (
                <>
                  {/* Активный таб получает мягкую терракотовую «таблетку» под иконкой. */}
                  <span
                    className={`flex h-9 w-14 items-center justify-center rounded-full transition-colors duration-200 ${
                      isActive ? 'bg-primary-50' : 'bg-transparent'
                    }`}
                  >
                    <Icon className="h-[22px] w-[22px]" />
                  </span>
                  {label}
                </>
              )}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}
